import { IDTypes } from '@/constants/reports'
import { PaySmallSmallCreditConfig } from '@/types/transactions'
import { Wallet, WALLET_TYPE } from '@/repositories/wallet-repository'

export const DATE_TIME_FORMAT = 'ddd Do MMMM YYYY h:mm'

export const convertQueryParamToString = (value: string | string[] | undefined) => {
    if (!value) return ''
    if (Array.isArray(value)) {
        return value.join(',')
    }
    return value
}

export const ID_TYPES: Record<string, { name: string; value: string }> = {
    [IDTypes.GHANA_CARD]: {
        name: 'Ghana Card',
        value: IDTypes.GHANA_CARD,
    },
    [IDTypes.PASSPORT]: {
        name: 'Passport',
        value: IDTypes.PASSPORT,
    },
    [IDTypes.VOTERS_ID]: {
        name: `Voter's ID`,
        value: IDTypes.VOTERS_ID,
    },
    [IDTypes.DRIVERS_LICENSE]: {
        name: 'Drivers License',
        value: IDTypes.DRIVERS_LICENSE,
    },
    [IDTypes.NHIS]: {
        name: 'NHIS',
        value: IDTypes.NHIS,
    },
}

export const PSS_CONFIG_FALLBACK = {
    amountPerScore: 45,
    dailyLimitPercentage: 15,
    interest: 10.58,
    maxAllowableAmount: 5000,
    maxCreditScore: 850,
    maxScoreRequired: 500,
    minAllowableAmount: 500,
    minCreditScore: 300,
    minScoreRequired: 400,
    missedPaymentInterestPercentage: 0.36,
    weeklyLimitAmount: 40,
    interestComputationPercentage: 0.75,
    systemTime: new Date().toISOString(),
} as PaySmallSmallCreditConfig

export const ALLOWED_ORIGINS: string[] = [
    'http://localhost:3000',
    'https://powerapp.ecg.com.gh',
    'https://stgn-powerapp.gov-gh.com',
]

export const GHANA_GOV_WALLET: Wallet = {
    id: 'ghana.gov',
    walletType: WALLET_TYPE.GHANA_GOV,
    accountNumber: '',
    accountName: 'Generate Bank Pay-In-slip',
    providerName: 'ghana.gov',
    userMobileNumber: 'Pay At Any Bank',
    status: 'ACTIVE',
    createdAt: '2024-11-15T08:30:45Z',
    updatedAt: '2025-02-20T14:22:10Z',
    isChallenged: false,
    challengeReason: null,
    walletDescription: 'Pay At Any Bank',
} as Wallet
